var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41 1.13398C7.58064 1.00734 7.7875 0.938965 8 0.938965C8.2125 0.938965 8.41936 1.00734 8.59 1.13398C9.81 2.01398 12.5 4.72398 12.5 11.264C12.5 13.424 11.72 16.024 11.14 17.614C11 18.004 10.63 18.264 10.21 18.264H5.8C5.38 18.264 5 18.004 4.86 17.614C4.28 16.024 3.5 13.424 3.5 11.264C3.5 4.72398 6.19 2.01398 7.41 1.13398ZM10 9.26398C10 8.16398 9.1 7.26398 8 7.26398C6.9 7.26398 6 8.16398 6 9.26398C6 10.364 6.9 11.264 8 11.264C9.1 11.264 10 10.364 10 9.26398ZM3.69 18.784C3.21 17.554 2.17 14.614 2.02 11.914L0.89 12.664C0.33 13.044 0 13.664 0 14.334V18.784C0 19.494 0.71 19.974 1.37 19.714L3.69 18.784ZM16 18.784V14.334C16 13.664 15.67 13.044 15.11 12.674L13.98 11.924C13.83 14.614 12.78 17.564 12.31 18.794L14.63 19.724C15.29 19.974 16 19.494 16 18.784Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/Rocket.be24ee9799cd56ca6dc8292ac3eb7bcc.svg";
export { ForwardRef as ReactComponent };